import { BankDetails, CreditCardDetails, ExternalCheckoutDetails, Payment } from "./Payment"

export type OnlinePaymentReceipt = {
    id: string,
    isDeclined: boolean,
    paymentType: string,
    icon: string,
    isDeposit: boolean,
    createdAt: string,
    currency: string,
    amount: string,
    creditCardDetails: CreditCardDetails,
    bankDetails: BankDetails,
    externalCheckoutDetails: ExternalCheckoutDetails,
    status: string,
    notes: string,
    terminalId: string,
    applicationLabel: string,
    authorizationCode: string,
    transactionCertificate: string,
    createdByUserId: string,
}

export const ConvertPaymentToOnlinePaymentReceipt = (pay: Payment, isDeposit: boolean) => {
    return {
        id: pay.id,
        isDeclined: pay.attributes.status === "declined",
        paymentType: pay.attributes.type,
        icon: "",
        isDeposit: isDeposit,
        createdAt: pay.attributes.createdAt,
        currency: pay.attributes.currency,
        amount: pay.attributes.amount,
        creditCardDetails: pay.attributes.integratedPayment ?
            pay.attributes.integratedPayment.attributes.creditCardDetails : null,
        bankDetails: pay.attributes.integratedPayment ?
            pay.attributes.integratedPayment.attributes.bankAccountDetails : null,
        externalCheckoutDetails: pay.attributes.integratedPayment ?
            pay.attributes.integratedPayment.attributes.externalCheckoutDetails : null,
        status: pay.attributes.status,
        notes: pay.attributes.note,
        terminalId: pay.attributes.terminalId,
        applicationLabel: pay.attributes.applicationLabel,
    }
}


// WEBPACK FOOTER //
// ./src/state/helpers/OnlinePaymentReceipt.ts